import React from 'react';
import './MessageItem.css';

const MessageItem = ({ message, isOwn }) => {
  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  // Function to format message with job links as cards
  const formatMessageWithLinks = (text) => {
    if (!text) return '';
    
    // Check if message contains "View Job:" followed by a URL
    const jobLinkRegex = /View Job:\s*(https?:\/\/[^\s]+)/i;
    const jobLinkMatch = text.match(jobLinkRegex);
    
    if (jobLinkMatch) {
      const jobUrl = jobLinkMatch[1];
      const messageParts = text.split(jobLinkRegex);
      const beforeJobLink = messageParts[0].trim();
      const afterJobLink = messageParts[2]?.trim() || '';
      
      return (
        <>
          {beforeJobLink && <span>{beforeJobLink}</span>}
          <div className="message-job-card">
            <a
              href={jobUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="message-job-card-button"
              onClick={(e) => e.stopPropagation()}
            >
              View Job
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </a>
          </div>
          {afterJobLink && <span>{afterJobLink}</span>}
        </>
      );
    }
    
    // Fallback: Regular URL links for other URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);
    
    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="message-link"
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div className={`message-item ${isOwn ? 'own' : 'other'} ${message.is_pending ? 'pending' : ''}`}>
      {!isOwn && (
        <div className="message-avatar">
          {message.user_profile_photo ? (
            <img src={message.user_profile_photo} alt={message.user_name} />
          ) : (
            <div className="message-avatar-placeholder">
              {message.user_name?.charAt(0).toUpperCase() || 'U'}
            </div>
          )}
        </div>
      )}
      
      <div className="message-content">
        {!isOwn && (
          <div className="message-sender">{message.user_name}</div>
        )}
        <div className="message-bubble">
          <div className="message-text">{formatMessageWithLinks(message.message)}</div>
          <span className="message-time">
            {formatTime(message.created_at)}
            {isOwn && !message.is_pending && (
              <span className={`message-status ${message.is_read ? 'read' : 'sent'}`} title={message.is_read ? 'Read' : 'Sent'}>
                {message.is_read ? '✓✓' : '✓'}
              </span>
            )}
            {!isOwn && message.is_read && (
              <span className="message-read-indicator" title="You read this message">✓</span>
            )}
          </span>
          {isOwn && message.is_pending && (
            <div className="message-sending-status">sending</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageItem;

